import { maestroApiCall } from '@michelin/central-provider';
import { getGooglePlacesInfo as getPlaceInfo, getGooglePlacesPhotoUrls as getPlacePhotoUrl } from './APITypes';

export interface GooglePlacesMapInfo {
  google_places_id?: string;
  geo_code_latitude?: string;
  geo_code_longitude?: string;
  requested_geo_code_update?: boolean;
  requested_geo_code_explanation?: string;
  requested_geo_code_latitude?:string;
  requested_geo_code_longitude?:string;
}
export interface GooglePlacesInfo {
  place_id: string;
  formatted_phone_number: string;
  formatted_address: string;
  international_phone_number: string;
  geometry: GooglePlacesGeometry;
  icon: string;
  name: string;
  opening_hours: GooglePlacesOpeningHours;
  photos: GooglePlacesPhoto[];
  plus_code: GooglePlacesPlusCode;
  price_level: number;
  rating: number;
  reviews: GooglePlacesReview[];
  types: string[];
  url: string;
  user_ratings_total: number;
  utc_offset: number;
  vicinity: string;
  website: string;
}

interface GooglePlacesGeometry {
  location: GooglePlacesLatLng;
  viewport: GooglePlacesViewport;
}

interface GooglePlacesViewport {
  northeast: GooglePlacesLatLng;
  southwest: GooglePlacesLatLng;
}

export interface GooglePlacesLatLng {
  lat: number;
  lng: number;
  location_type: string;
}

interface GooglePlacesOpeningHours {
  open_now: boolean;
  periods: GooglePlacesOpeningHoursPeriod[];
  weekday_text: string[];
}

interface GooglePlacesOpeningHoursPeriod {
  close: GooglePlacesOpeningHoursPeriodTime;
  open: GooglePlacesOpeningHoursPeriodTime;
}

interface GooglePlacesOpeningHoursPeriodTime {
  day: number;
  time: string;
}

interface GooglePlacesPhoto {
  height: number;
  html_attributions: string[];
  photo_reference: string;
  width: number;
}

interface GooglePlacesPlusCode {
  compound_code: string;
  global_code: string;
}

interface GooglePlacesReview {
  author_name: string;
  author_url: string;
  language: string;
  profile_photo_url: string;
  rating: number;
  relative_time_description: string;
  text: string;
  time: number;
}

export interface GooglePlacesAddress {
  address?: string;
  address2?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
}

export async function getGooglePlacesPhotoUrls(photoReferences: string[], width: number): Promise<string[] | null> {
  try {
    const newData = { photoReferences, width };

    const data = await maestroApiCall(getPlacePhotoUrl(), newData);

    return data.result;
  } catch (e) {
    return null;
  }
}

export async function getGooglePlacesInfo(placeId: string): Promise<GooglePlacesInfo | null> {
  try {
    const data = await maestroApiCall(getPlaceInfo(placeId));

    return data.result;
  } catch (e) {
    return null;
  }
}
